import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import PhotoCarousel from './PhotoCarousel'

export default function PhotoCarouselModal({
    photos,
    isOpen,
    onClose,
    currentPhotoIndex = 0,
    setCurrentPhotoIndex,
    showBackgroundBlur = false,
    onPhotoIndexChange = null,
    showTypeLabel = false,
    animationType = "fade",
    maxDots = 100,
    navigationSize = "large"
}) {
    // Disable/enable background scrolling when modal opens/closes
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }
        return () => {
            document.body.style.overflow = ''
        }
    }, [isOpen])

    if (!photos?.length) {
        return null
    }

    const modalContent = (
        <div className={`fixed inset-0 z-[9999] bg-black md:bg-opacity-75 flex items-center justify-center p-0 md:p-4 transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
            <div
                className="absolute inset-0 bg-black bg-opacity-50 md:bg-opacity-30"
                onClick={onClose}
                aria-label="Close gallery"
            />

            <div className={`relative bg-black md:bg-opacity-90 md:rounded-lg md:shadow-2xl md:max-w-7xl md:max-h-[95vh] w-full h-full flex flex-col overflow-hidden transform transition-all duration-300 ${isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
                <div className="absolute top-4 left-4 md:top-6 md:left-6 z-50">
                    <button
                        onClick={onClose}
                        className="bg-gray-600 bg-opacity-80 hover:bg-opacity-90 border-none rounded-full w-12 h-12 flex items-center justify-center cursor-pointer transition-all duration-300 text-white shadow-lg hover:scale-110"
                        aria-label="Close gallery"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <PhotoCarousel
                    photos={photos}
                    currentPhotoIndex={currentPhotoIndex}
                    setCurrentPhotoIndex={setCurrentPhotoIndex}
                    className="flex-1"
                    showBackgroundBlur={showBackgroundBlur}
                    onPhotoIndexChange={onPhotoIndexChange}
                    showTypeLabel={showTypeLabel}
                    animationType={animationType}
                    maxDots={maxDots}
                    navigationSize={navigationSize}
                    zIndex={60}
                />
            </div>
        </div>
    )

    return createPortal(modalContent, document.body)
}
